import { render, staticRenderFns } from "./SafetyAssistant.vue?vue&type=template&id=7023fe20&scoped=true"
import script from "./SafetyAssistant.vue?vue&type=script&lang=js"
export * from "./SafetyAssistant.vue?vue&type=script&lang=js"
import style0 from "./SafetyAssistant.vue?vue&type=style&index=0&id=7023fe20&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023fe20",
  null
  
)

export default component.exports